<template>
  <VRow no-gutters class="preloader" :class="{ 'preloader--fullscreen': fullscreen }">
    <VCol cols="12" class="text-center">
      <VProgressCircular
        indeterminate
        color="blue"
        :size="size"
        :width="width"
      />
      <div v-if="text" class="preloader-text">
        {{ $t(`${text}`) }}
      </div>
    </VCol>
  </VRow>
</template>

<script>
export default {
  name: 'Preloader',
  props: {
    size: {
      type: Number,
      default: 50,
    },
    width: {
      type: Number,
      default: 3,
    },
    text: {
      type: String,
      default: null,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.preloader {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preloader--fullscreen {
  position: fixed;
  inset: 0;
  z-index: 200;
  min-height: 100vh;
  height: auto;
}
.preloader-text {
  max-width: 600px;
  color: #212121;
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  line-height: 140%;
  margin: 15px auto 0;
}
</style>
